import React from 'react'
import { Link } from 'react-router-dom'
import Button from '../Button/Button'
import './MnRequestStyle.css'

const MnRequest = ({ name, type, profileImg, linkedin, imgLoading, company, acceptreq, joinbtn, compdata, exp, expdata, dom, domdata, ment, mentdata, dataclass, onAccept, onReject }) => {
    return (
        <div className='mnMentorRequstcardwrap'>
            <div className="CradDataAdminDs">

                <div className="UsersCardDsAd">
                    <div className='MnreqWrapbaricons'>
                        <div className="UserCradnameDs flexbox">
                            {imgLoading ? imgLoading : <img src={profileImg ? profileImg : "/assets/img/User.png"} alt="" className='imgslidereq' />}
                            <div className='textDsAdname'>
                                <h3>{name}</h3>
                                <p>{type}</p>
                            </div>
                        </div>
                        {linkedin ?
                            <a className='linkedintext mt-10' href={linkedin} target='_blank' rel='noreferrer'>
                                <span className='flex gap-2'>
                                    Linkedin
                                    <img src="/assets/img/send.png" alt="" />
                                </span>
                            </a> : ''}
                    </div>
                    {
                        acceptreq && <div className='approveReject gap-10 flex'>
                            <span className='pointer righttick' onClick={onAccept}>
                                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="34" height="34" rx="17" fill="#FAFAFA" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M19.8236 10.6631C18.4571 10.0542 16.9303 9.90338 15.4711 10.2331C14.0119 10.5628 12.6983 11.3553 11.7263 12.4926C10.7543 13.6298 10.176 15.0508 10.0775 16.5435C9.97911 18.0363 10.3659 19.5209 11.1801 20.7759C11.9944 22.031 13.1925 22.9891 14.5958 23.5076C15.9991 24.026 17.5324 24.077 18.967 23.6528C20.4017 23.2286 21.6607 22.3521 22.5565 21.1539C23.4522 19.9557 23.9366 18.5 23.9375 17.004V16.3143C23.9375 16.0036 24.1893 15.7518 24.5 15.7518C24.8107 15.7518 25.0625 16.0036 25.0625 16.3143V17.0043C25.0615 18.7429 24.4985 20.4349 23.4575 21.8275C22.4165 23.22 20.9533 24.2387 19.286 24.7316C17.6187 25.2246 15.8368 25.1654 14.2059 24.5629C12.575 23.9604 11.1826 22.8468 10.2363 21.3883C9.29005 19.9297 8.84058 18.2044 8.95498 16.4695C9.06937 14.7347 9.7415 13.0833 10.8711 11.7616C12.0007 10.44 13.5273 9.51889 15.2232 9.13573C16.919 8.75257 18.6933 8.92787 20.2814 9.63549C20.5652 9.76193 20.6927 10.0945 20.5663 10.3782C20.4399 10.662 20.1073 10.7895 19.8236 10.6631ZM24.8975 10.6021C25.1173 10.8216 25.1175 11.1778 24.8979 11.3975L17.3979 18.905C17.2925 19.0106 17.1494 19.07 17.0001 19.07C16.8509 19.07 16.7078 19.0108 16.6023 18.9052L14.3523 16.6552C14.1326 16.4356 14.1326 16.0794 14.3523 15.8598C14.5719 15.6401 14.9281 15.6401 15.1477 15.8598L16.9998 17.7118L24.1021 10.6025C24.3216 10.3827 24.6778 10.3825 24.8975 10.6021Z" fill="#7BC896" />
                                </svg>
                            </span>
                            <span className='pointer wrongtick' onClick={onReject}>
                                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="34" height="34" rx="17" fill="#FAFAFA" />
                                    <path opacity="0.8" fillRule="evenodd" clipRule="evenodd" d="M11.1953 11.1953C11.4556 10.9349 11.8777 10.9349 12.1381 11.1953L17 16.0572L21.8619 11.1953C22.1223 10.9349 22.5444 10.9349 22.8047 11.1953C23.0651 11.4556 23.0651 11.8777 22.8047 12.1381L17.9428 17L22.8047 21.8619C23.0651 22.1223 23.0651 22.5444 22.8047 22.8047C22.5444 23.0651 22.1223 23.0651 21.8619 22.8047L17 17.9428L12.1381 22.8047C11.8777 23.0651 11.4556 23.0651 11.1953 22.8047C10.9349 22.5444 10.9349 22.1223 11.1953 21.8619L16.0572 17L11.1953 12.1381C10.9349 11.8777 10.9349 11.4556 11.1953 11.1953Z" fill="#EF5350" />
                                </svg>
                            </span>
                        </div>
                    }

                    {
                        joinbtn && <Button name={'Join Call'} className={'joincall'} onClick={() => window.open(joinbtn)} />
                    }
                </div>

            </div>

            <div className='MentorDsAdResquests flexbox'>

                <div className={`AdDsWrapdataReq ${dataclass}`}>
                    {company} <strong>{compdata}</strong>
                </div>

                <div className="AdDsWrapdataReq">
                    {exp} <strong>{expdata}</strong>
                </div>

                <div className="AdDsWrapdataReq">
                    {dom} <strong>{domdata}</strong>
                </div>

                <div className="AdDsWrapdataReq">
                    {ment} <strong>{mentdata}
                    </strong>
                </div>

            </div>
        </div>
    )
}

export default MnRequest